// extracted by mini-css-extract-plugin
export default {"head":"company_head__OdAxr","active":"company_active__dr4Eo","nav":"company_nav__7jekI"};